import React, { useState, useEffect, useRef, useContext } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Center,
  Select,
  Pagination,
  Checkbox,
  Tabs,
  Badge,
  Button,
  Loader,
} from "@mantine/core";
import {
  IconSearch,
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconTrash,
  IconChecklist,
  IconUserPlus,
  IconEye,
  IconTruck,
  IconPercentage,
  IconEdit,
  IconBrandTabler,
} from "@tabler/icons-react";
import classes from "./GamesFPS.module.css";
// import DeleteStaff from "./DeleteStaff";
import { RowDataGames } from "./types";
import { props } from "./props";
import { CustomTable } from "../Table/CustomTable";
import { games } from "../types/RowDataTypes";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  showErrorAlert,
  showEditWarning,
  showSuccessAlert,
} from "../../helper/alerts";
import Header from "../static/Header";
import AddGameModal from "./AddGameModal";
import EditGameModal from "./EditGameModal";
// import VerifyDealer from "./VerifyDealer";
import getGamesTable from "../../DataDisplay/DataDisplayTable/GamesTable";

import { formatDD_MM_YYYY } from "../../helper/DateTime";


enum ColumnHeaderToFilterPair {
    NAME = "Name",
    SHOW = "Show",
}

const colFilter = ColumnHeaderToFilterPair;
const colFilters: { [key in ColumnHeaderToFilterPair]: string } = {
  [colFilter.NAME]: "name",
  [colFilter.SHOW]: "show",
};

function Th({ children, sortable, reversed, sorted, onSort }: props) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;

  let allowedSorts;

  allowedSorts = [
    colFilter.NAME.toString().toLowerCase(),
    // colFilter.FULLNAME.toString().toLowerCase(),
    // colFilter.CREATEDAT.toString().toLowerCase(),
    // colFilter.CONTACTNO.toString().toLowerCase(),
    // colFilter.EMAIL.toString().toLowerCase(),
    // colFilter.DOB.toString().toLowerCase(),
];
  const isCurrent =
    window.location.href.split("/")[5] === "all" ? true : false;
//   console.log("the children");
//   console.log(children);
//   console.log(allowedSorts);
//   console.log(allowedSorts.includes(children!!.toString().toLowerCase()));

  return children!! === "action" && !isCurrent ? (
    <></>
  ) : (
    <Table.Th className={`${classes.th} ${sortable ? classes.sortable : ""}`}>
      {allowedSorts.includes(children!!.toString().toLowerCase()) ? (
        <UnstyledButton onClick={onSort} className={classes.control}>
          <div className={classes.sortableHeader}>
            <Text fw={500} fz="sm">
              {children}
            </Text>
            <Center className={classes.icon}>
              <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </Center>
          </div>
        </UnstyledButton>
      ) : (
        <Text fw={500} fz="sm">
          {children}
        </Text>
      )}
    </Table.Th>
  );
}

const initialData: RowDataGames[] = [
  {
    id: 0,
    name: "",
    img: "",
    show: false,
    createdAt: "", 
    updatedAt: "", 

    action: "",
  },
];

export function GamesFPSGames() {
  const axiosPrivate = useAxiosPrivate();
  const nav = useNavigate();
  const [search, setSearch] = useState<string>("");
  const [sortedData, setSortedData] = useState(initialData);
  const [sortBy, setSortBy] = useState<keyof RowDataGames | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(false);

  const [addGameModalOpen,setAddGameModalOpen] = useState(false)
  const [editGameModalOpen,setEditGameModalOpen] = useState(false)

  const [selectedRowForEdit, setSelectedRowForEdit] =
    useState<RowDataGames | null>(null);


  const [tableStateChanged, setTableStateChanged] = useState(0);
  const changeTableState = () => {
    setTableStateChanged(Math.random() * Math.random());
  };

  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const resetPage = () => {
    if (currentPage !== 1) {
      setCurrentPage(1);
      return true;
    }
    return false;
  };

  const checkboxesFilter: JSX.Element[] = [];

  //Set allowed search filter checkbox to be shown
  const allowedFilters = [
    colFilters[colFilter.NAME],
  ];

  for (const [key, value] of Object.entries(colFilters)) {
    if (allowedFilters.includes(value)) {
      const checkboxFilter: JSX.Element = (
        <Checkbox value={value} label={key} />
      );
      checkboxesFilter.push(checkboxFilter);
    }
  }

  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearch(input);
  };

  const location = useLocation();
  const fetchedData = useFetchRowData(
    itemsPerPage,
    currentPage,
    search,
    selectedFilters,
    tableStateChanged,
    sortBy ?? "createdAt",
    reverseSortDirection ? "DESC" : "ASC",
    games,
    getGamesTable().create(),
    {
      current: location.pathname.split("/")[2] ?? "all",
    //   current: "unverified",
    },
  );

  const itemsOnPage = useRef(0);
  const totalRows = fetchedData.totalRows;
  const rowData: RowDataGames[] | null = fetchedData.data as RowDataGames[];
//   const isLoading: boolean = fetchedData.isLoading;
  const [RowDataDealer, setRowDataDealer] = useState<RowDataGames[] | null>(null);

  useEffect(() => {
    setRowDataDealer(rowData);
    itemsOnPage.current = fetchedData.itemsOnPage;
  }, [rowData]);

  const [selectedRow, setSelectedRow] = useState<RowDataGames | null>(null);
  const [isEditMode, setEditMode] = useState(false);
  const handleEdit = (row: RowDataGames) => {
    setSelectedRow(row);

    // Check if the current page is "pass", then show the edit warning
    if (location.pathname.split("/")[2] === "all") {
      showEditWarning("Are you sure you want to edit this dealer?", setEditMode);
    } else {
      // If the page is not "pass", directly setEditMode to true
      setEditMode(true);
    }
  };

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;

  const handleVerifyDealer = (
    editedData: RowDataGames,
    originalData: RowDataGames | null,
    action: string,
    remark: string,
  ) => {
    if (originalData) {
      const paramsToUpdate = {
        // uid: originalData.uid,
        // action: action,
        // remark: remark,
      };

      axiosPrivate
        .post("/api/admin/dealer/verify-dealer", paramsToUpdate)
        .then((response) => {
          if (
            itemsOnPage.current == 1 &&
            currentPage !== 1 &&
            currentPage == Math.ceil(totalRows / itemsPerPage)
          )
            setCurrentPage((prev) => prev - 1);
          else changeTableState();
          showSuccessAlert("Dealer Successfully Updated");
        })
        .catch((error) => {
          showErrorAlert("An error has occured");
        });
    }

    setEditMode(false);
  };

  const toggleVisibility = async (row: RowDataGames, e: any) => {
    e.target.disabled = true;
    let endpoint;
    if (!row.show) endpoint = "/api/admin/games/show";
    else endpoint = "/api/admin/games/hide";

    await axiosPrivate
      .post(endpoint, {
        id: row.id,
      })
      .then((response) => {
        const indexOfSelectedRow = RowDataDealer!!.findIndex((e) => e === row);

        // Create a copy of the sortedData
        const updatedData = [...RowDataDealer!!];

        // Update the selectedRow in the copied data
        updatedData[indexOfSelectedRow] = {
          ...row,
          show: !row.show,
        };

        setRowDataDealer(updatedData);
      })
      .catch((err) => {
        showErrorAlert("An error occured");
      });

    e.target.disabled = false;
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
  };

  const isCurrent =
    location.pathname.split("/")[2] === "all" ? true : false;
  const rowsToMap = RowDataDealer ?? [];
  const rows = rowsToMap.map((row, index) => (
    <Table.Tr key={index}>
      <Table.Td>{startIndex + index + 1}</Table.Td>
      {/* <Table.Td ><Badge variant="outline" color="dark">{row.category}</Badge></Table.Td> */}
      <Table.Td>{row.name}</Table.Td>
      {/* <Table.Td>{row.displayName}</Table.Td>
      <Table.Td>{row.brand}</Table.Td>
      <Table.Td>{row.price}</Table.Td> */}
      <Table.Td className={classes.colorAndButtonColumn}>
        <Button
          className={classes.showButton}
          style={{
            backgroundColor: row.show ? "#2BDD66" : "#0014AD",
          }}
          onClick={(e) => toggleVisibility(row, e)}
        >
          {row.show ? "ON" : "OFF"}
        </Button>
      </Table.Td>
      <Table.Td className={classes.actionButtons}>
        <UnstyledButton onClick={()=>handleEditModal(row)}>
            <button className={classes.editbutton}>
                <IconEdit /> Edit Game
            </button>
        </UnstyledButton>
      </Table.Td>
    </Table.Tr>
  ));

  const handleSelectPage = (selectedPage: number) => {
    if (selectedPage != currentPage) setCurrentPage(selectedPage);
  };

  

  const handleTabChange = (val: string | null) => {
    val = val ?? "all";
    nav(`/games-fps/${val}`);
    changeTableState();
  };

  const handleSorting = (val: any) => {
    setReverseSortDirection(!reverseSortDirection);
    setSortBy(val);
    changeTableState();
    // console.log("sorting");
    // console.log(val);
    // console.log(reverseSortDirection);
  };

  const handleAddGame = (newBannerData: RowDataGames) => {
    setIsLoading(true);
    axiosPrivate
      .post(
        "/api/admin/games/create",
        {
            name: newBannerData.name,
            image: newBannerData.img,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      )
      .then((response) => {
        // console.log(response);
        changeTableState()
        setIsLoading(false);
        showSuccessAlert("Game Successfully Added");
      })
      .catch((error) => {
        // console.log("error " + error);
        setIsLoading(false);
        showErrorAlert("Something Went Wrong");
      });
  };

  const handleEditGame = (editedBannerData: RowDataGames) => {

    let params: any = {
      id: editedBannerData.id,
      name: editedBannerData.name,
    }

    if (!(!editedBannerData.img.path))
      params["image"] = editedBannerData.img


    // console.log(params)
    axiosPrivate
      .post("/api/admin/games/update", params,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
      .then((response) => {

        changeTableState()
        showSuccessAlert("Banner Successfully Edited");
      })
      .catch((error) => {
        // console.log("error " + error);
        showErrorAlert("Something Went Wrong");
      });
    setEditGameModalOpen(false);
  };

  const handleAddModalOpen = () => {
    setAddGameModalOpen(true);
  };

  const handleAddModalClose = () => {
    setAddGameModalOpen(false);
  }

  const handleEditModal = (row: RowDataGames) => {
    setSelectedRowForEdit(row);
    setEditGameModalOpen(true);
  };

  return (
    <div className={classes.orderContainer}>
    {isLoading && (
        <div className={classes.loadingOverlay}>
          <Loader size="xl" />
        </div>
      )}
      <ScrollArea className={classes.parentContainer}>
        <Header
          title={
            <div>
              <p>Games FPS</p>
            </div>
          }
        />

        <div className={classes.searchBarContainer}>
          <SearchBar
            isLoading={isLoading}
            resetPage={resetPage}
            changeTableState={changeTableState}
            search={search}
            handleSearch={handleSearch}
            setShowFilterOptions={setShowFilterOptions}
            showFilterOptions={showFilterOptions}
            selectedFilters={selectedFilters}
            setSelectedFilters={setSelectedFilters}
            checkboxesFilter={checkboxesFilter}
          />
          <div className={classes.AddButtonContainer}>
            <Button className={classes.addButton} onClick={handleAddModalOpen}>
              <IconBrandTabler className={classes.iconBrandTabler} />
              Create Games
            </Button>
          </div>
        </div>

        <AddGameModal
          isOpen={addGameModalOpen}
          onClose={handleAddModalClose}
          onAdd={handleAddGame}
        />

        <EditGameModal
          isOpen={editGameModalOpen}
          onClose={() => setEditGameModalOpen(false)}
          onEdit={handleEditGame}
          data={selectedRowForEdit || initialData[0]}
        />

        <Tabs
          defaultValue="games"
          color="blueviolet"
          variant="pills"
          onChange={(value) => {
            handleTabChange(value);
          }}
        >
            <Tabs.List className={classes.tabHeader}>
                <Tabs.Tab value="gpu" className={classes.tabTitle}>
                    GPU Model
                </Tabs.Tab>
                <Tabs.Tab value="games" className={classes.tabTitle}>
                    Games
                </Tabs.Tab>
            </Tabs.List>
          <ScrollArea
            // w={
            //   window.innerWidth -
            //   document.getElementById("nav-bar")!!.getBoundingClientRect().width
            // }
          >
            <Tabs.Panel value="gpu">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

            <Tabs.Panel value="games">
              <CustomTable
                colHeaders={Object.values(ColumnHeaderToFilterPair)}
                filters={Object.values(colFilters)}
                reverseSortDirection={reverseSortDirection}
                sortBy={sortBy}
                setSorting={handleSorting}
                customclasses={classes}
                Th={Th}
                rowData={rowData}
                rows={rows}
              />
            </Tabs.Panel>

          </ScrollArea>

        </Tabs>

        <div className={classes.footerContainer}>
          <div className={classes.resultCount}>
            <Text>
              {`Showing `}
              <span style={{ fontWeight: "bold" }}>{startIndex + 1}</span>
              {`-`}
              <span style={{ fontWeight: "bold" }}>
                {Math.min(currentPage * itemsPerPage, totalRows)}
              </span>
              {` of `}
              <span style={{ fontWeight: "bold" }}>{totalRows}</span>
              {` results `}
            </Text>
          </div>

          <div className={classes.rightContainer}>
            <div className={classes.rowsPerPageSelector}>
              <Select
                placeholder="Rows per page"
                data={["10", "20", "50"]}
                value={itemsPerPage.toString()}
                onChange={(value) =>
                  handleRowsPerPageChange(parseInt(value as string, 10))
                }
              />
            </div>

            <div className={classes.paginationSelector}>
              <Pagination
                color="blueviolet"
                value={currentPage}
                total={Math.ceil(totalRows / itemsPerPage)}
                onNextPage={() => handlePageChange(currentPage + 1)}
                onPreviousPage={() => handlePageChange(currentPage - 1)}
                onChange={(value: number) => handleSelectPage(value)}
              />
            </div>
          </div>
        </div>

        {/*isEditMode && (
          <VerifyDealer
            isOpen={isEditMode}
            onClose={() => setEditMode(false)}
            onSaveChanges={(editedData, action, remark) =>
                handleVerifyDealer(editedData, selectedRow, action, remark)
            }
            initialData={selectedRow as RowDataDealer}
          />
        )*/}
      </ScrollArea>
    </div>
  );
}

export default GamesFPSGames;
